import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { initMixpanel } from './utils/mixpanel';
import Home from './pages/Home';
import MedhaScribeCaseStudy from './pages/MedhaScribeCaseStudy';
import HealofyCaseStudy from './pages/HealofyCaseStudy';
import DesignMaturityCaseStudy from './pages/DesignMaturityCaseStudy';
import NHCareCaseStudy from './pages/NHCareCaseStudy';
import JewelleryBilling from './components/JewelleryBilling'; // New Component

// Helper component to scroll to top on route change
const ScrollToTopHelper = () => {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
};

function App() {
  React.useEffect(() => {
    initMixpanel();
  }, []);

  return (
    <Router>
      <ScrollToTopHelper />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/clinical-tool" element={<MedhaScribeCaseStudy />} />
        <Route path="/healofy-growth" element={<HealofyCaseStudy />} />
        <Route path="/maturity" element={<DesignMaturityCaseStudy />} />
        <Route path="/nh-care" element={<NHCareCaseStudy />} />
        
        {/* New SwarnaERP Route */}
        <Route path="/swarnaerp" element={<JewelleryBilling />} />
        
        {/* Placeholders for future pages */}
        <Route path="/project-0" element={<div className="min-h-screen flex items-center justify-center bg-pastel-bg text-neutral-500">Work in Progress</div>} />
        <Route path="/analytics" element={<div className="min-h-screen flex items-center justify-center bg-pastel-bg text-neutral-500">Analytics Case Study Coming Soon</div>} />
        <Route path="/foundations" element={<div className="min-h-screen flex items-center justify-center bg-pastel-bg text-neutral-500">Design Foundations Case Study Coming Soon</div>} />
        <Route path="/healofy-community" element={<div className="min-h-screen flex items-center justify-center bg-pastel-bg text-neutral-500">Community Growth Case Study Coming Soon</div>} />
        <Route path="/healofy-ds" element={<div className="min-h-screen flex items-center justify-center bg-pastel-bg text-neutral-500">Design System Case Study Coming Soon</div>} />
      </Routes>
    </Router>
  );
}

export default App;
